import React from 'react';
import { arrayOf, bool, object, shape, string } from 'prop-types';
import map from 'lodash/map';
import Field from 'redux-form/es/Field';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import InputRadioBox from '../../../Core/Controls/InputRadioBox';
import InputField from '../../../Core/Controls/InputField';

const RadioBoxesWithInput = (props) => {
  const { options, fieldName, shouldShowTextInput, textInputName, textInputTitleId } = props;

  const handleOptionTitle = (option) => {
    if (option.translationValues) {
      return (
        <FormattedHTMLMessage
          id={option.title}
          values={option.translationValues}
        />
      );
    }

    return <FormattedMessage id={option.title} />;
  };

  return (
    <div className="followup__question-group-radioboxes">
      {
        map(options, (option) => (
          <Field
            key={option.title}
            title={handleOptionTitle(option)}
            name={fieldName}
            component={InputRadioBox}
            val={option.value}
          />
        ))
      }

      {
        shouldShowTextInput && (
          <Field
            type="text"
            component={InputField}
            name={textInputName}
            isFullWidth
            title={<FormattedMessage id={textInputTitleId} />}
            isErrorVisible
          />
        )
      }
    </div>
  );
};

RadioBoxesWithInput.propTypes = {
  options: arrayOf(shape({
    title: string,
    translationValues: object,
    value: string,
  })),
  fieldName: string,
  shouldShowTextInput: bool,
  textInputName: string,
  textInputTitleId: string,
};

export default RadioBoxesWithInput;
